module.exports = __webpack_public_path__ + "assets/video.5827d424.svg";